import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useNavigate } from "react-router-dom";
import { getRootStore } from "@/stores/RootStore";
import { parseBotMessage, AccentColor, BotMessageType, } from "@/utils/formatBotMessage";
import styles from "@/styles/BotMessageCard.module.less";
const ACCENT_CLASS = {
    [AccentColor.GREEN]: styles["accent--green"],
    [AccentColor.BLUE]: styles["accent--blue"],
    [AccentColor.GOLD]: styles["accent--gold"],
    [AccentColor.RED]: styles["accent--red"],
    [AccentColor.ORANGE]: styles["accent--orange"],
    [AccentColor.GRAY]: styles["accent--gray"],
};
const ICON_BG_CLASS = {
    [AccentColor.GREEN]: styles["iconWrap--green"],
    [AccentColor.BLUE]: styles["iconWrap--blue"],
    [AccentColor.GOLD]: styles["iconWrap--gold"],
    [AccentColor.RED]: styles["iconWrap--red"],
    [AccentColor.ORANGE]: styles["iconWrap--orange"],
    [AccentColor.GRAY]: styles["iconWrap--gray"],
};
function formatTime(ts) {
    return new Date(ts).toLocaleTimeString("ru-RU", {
        hour: "2-digit",
        minute: "2-digit",
    });
}
const FieldsSection = ({ fields }) => {
    if (fields.length === 0)
        return null;
    return (_jsx("div", { className: styles.section, children: _jsx("div", { className: styles.kv, children: fields.map((f, i) => (_jsxs(React.Fragment, { children: [_jsx("span", { className: styles.kvLabel, children: f.label }), _jsx("span", { className: styles.kvValue, children: f.value })] }, i))) }) }));
};
/** WP-DSP-FIX-01 (D16в): кто платит — заметно, с бейджем «корп.» у корпоративного заказа. */
const PayerSection = ({ payer }) => {
    if (payer === null)
        return null;
    return (_jsx("div", { className: `${styles.section} ${payer.corporate ? styles["section--corp"] : ""}`, "data-testid": "bot-card-payer", children: _jsxs("div", { className: styles.payerRow, children: [_jsx("span", { className: styles.kvLabel, children: "\u041F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A" }), _jsx("span", { className: styles.payerName, children: payer.name }), payer.corporate ? (_jsx("span", { className: styles.corpBadge, "data-testid": "bot-card-corp-badge", children: "\u043A\u043E\u0440\u043F." })) : null] }) }));
};
/** WP-DSP-FIX-01: строки поста, которые разбор не распознал, — текстом, а не молча выброшенными. */
const ExtraLinesSection = ({ lines }) => {
    if (lines.length === 0)
        return null;
    return (_jsx("div", { className: styles.section, children: lines.map((line, i) => (_jsx("div", { className: styles.plainText, children: line }, i))) }));
};
const OrderListSection = ({ items }) => {
    if (items.length === 0)
        return null;
    return (_jsx("div", { className: styles.section, children: _jsx("div", { className: styles.orderList, children: items.map((item, i) => (_jsxs("div", { className: styles.orderItem, children: [_jsx("span", { className: styles.orderNumber, children: item.number }), _jsx("span", { className: styles.orderAddress, children: item.address }), item.status && (_jsx("span", { className: styles.orderStatus, children: item.status }))] }, i))) }) }));
};
const BotMessageCard = ({ text, timestamp }) => {
    const navigate = useNavigate();
    const parsed = parseBotMessage(text);
    const handleOpenOrder = () => {
        if (!parsed.orderNumber)
            return;
        const { orderStore } = getRootStore();
        orderStore.filtersStore.updateFilter("search", parsed.orderNumber);
        navigate("/orders");
    };
    const handleAssignRoute = () => {
        if (!parsed.orderNumber)
            return;
        const { orderStore } = getRootStore();
        orderStore.filtersStore.updateFilter("search", parsed.orderNumber);
        navigate("/orders");
    };
    const showActions = parsed.type === BotMessageType.UNROUTED_ORDER &&
        parsed.orderNumber !== null;
    return (_jsxs("div", { className: styles.card, children: [_jsx("div", { className: `${styles.accent} ${ACCENT_CLASS[parsed.accent]}` }), _jsxs("div", { className: styles.inner, children: [_jsxs("div", { className: styles.header, children: [_jsx("div", { className: `${styles.iconWrap} ${ICON_BG_CLASS[parsed.accent]}`, children: parsed.icon }), _jsx("span", { className: styles.title, children: parsed.title }), parsed.waitMinutes !== null && (_jsxs("span", { className: styles.waitBadge, children: ["\u043E\u0436\u0438\u0434\u0430\u0435\u0442 ", parsed.waitMinutes, " \u043C\u0438\u043D"] })), _jsx("span", { className: styles.time, children: formatTime(timestamp) })] }), parsed.warnings.length > 0 && (_jsx("div", { className: styles.warnings, children: parsed.warnings.map((w, i) => (_jsxs("div", { className: styles.warningRow, children: [_jsx("span", { children: "\u26A0\uFE0F" }), _jsx("span", { children: w })] }, i))) })), _jsx(FieldsSection, { fields: parsed.fields }), _jsx(PayerSection, { payer: parsed.payer }), _jsx(ExtraLinesSection, { lines: parsed.extraLines }), _jsx(OrderListSection, { items: parsed.orderList }), parsed.remainingText && (_jsx("div", { className: styles.section, children: _jsx("span", { className: styles.plainText, children: parsed.remainingText }) })), parsed.note && _jsx("div", { className: styles.note, children: parsed.note }), parsed.cta && !showActions && (_jsx("div", { className: styles.cta, children: parsed.cta })), showActions && (_jsxs("div", { className: styles.actions, children: [_jsx("button", { className: `${styles.btn} ${styles["btn--primary"]}`, onClick: handleAssignRoute, children: "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442" }), _jsx("button", { className: styles.btn, onClick: handleOpenOrder, children: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0437\u0430\u043A\u0430\u0437" })] }))] })] }));
};
BotMessageCard.displayName = "BotMessageCard";
export default BotMessageCard;
